exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "iframe {\n  height: 100%;\n  width: 100%;\n  display: block;\n  border: 0px none;\n  padding: 0px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/scormcloud/scorm-cloud.component.css
// module id = 762
// module chunks = 0